import { useQuery } from '@tanstack/react-query';
import type { CrmContactCandidate } from '@stromo/shared';
import { api } from './api';

export interface CrmStatus {
  enabled: boolean;
  type: 'braso' | null;
  ready: boolean;
  error: string | null;
}

/** Status der CRM-Integration. Wird beim Laden der Kontakte-Seite einmal
 *  abgefragt und bestimmt, ob der „Aus CRM importieren"-Knopf erscheint. */
export function useCrmStatus() {
  return useQuery({
    queryKey: ['crm', 'status'],
    queryFn: async () => {
      const { data } = await api.get<CrmStatus>('/crm/status');
      return data;
    },
    staleTime: 60_000,
  });
}

/** Suche im CRM. Server liefert max 25 Treffer, schon de-dupliziert
 *  und mit Information, ob die Person bereits importiert wurde. */
export function useCrmSearch(query: string, enabled: boolean) {
  const trimmed = query.trim();
  return useQuery({
    queryKey: ['crm', 'search', trimmed],
    queryFn: async () => {
      const { data } = await api.get<{ items: CrmContactCandidate[] }>('/crm/search', {
        params: { q: trimmed },
      });
      return data.items;
    },
    enabled: enabled && trimmed.length >= 2,
    staleTime: 30_000,
  });
}
